export default "__VITE_ASSET__Bd3mD85n__"